import { useEffect, useState } from 'react';
import { isCollectionScannerRoute } from '../components/layout/routeChrome';
import {
  hasPendingLastScanTip,
  lastScanSessionTotalQuantity,
  readLastScanSession,
  subscribeLastScanSessionChanged,
  type LastScanSession,
} from '../scan/lastScanSession';

/** Collection and the scanner already show the review, so the nav badge stays off. */
export function hidesPendingScanTip(pathname: string): boolean {
  return (
    isCollectionScannerRoute(pathname) ||
    pathname === '/collection' ||
    pathname.startsWith('/collection/sets/') ||
    pathname.startsWith('/collection/binders') ||
    pathname === '/features/collection'
  );
}

export function pendingScanTipCount(
  pathname: string,
  signedIn: boolean,
  session: LastScanSession | null,
): number {
  if (!signedIn || hidesPendingScanTip(pathname)) return 0;
  if (!hasPendingLastScanTip(session)) return 0;
  return lastScanSessionTotalQuantity(session);
}

export function usePendingScanTip(pathname: string, signedIn: boolean): number {
  const [count, setCount] = useState(() =>
    pendingScanTipCount(pathname, signedIn, readLastScanSession()),
  );

  useEffect(() => {
    const sync = () => setCount(pendingScanTipCount(pathname, signedIn, readLastScanSession()));
    sync();
    return subscribeLastScanSessionChanged(sync);
  }, [pathname, signedIn]);

  return count;
}
